import React from "react";
import { Link } from "react-router-dom";
import { ArrowLeft } from "lucide-react";
import Navbar from "@/components/Navbar";
import Footer from "@/components/Footer";

export function LegalShell({ title, children }) {
  return (
    <div className="min-h-screen bg-[#050505] text-white">
      <Navbar />
      <section className="max-w-3xl mx-auto px-6 md:px-10 py-20">
        <Link to="/" className="inline-flex items-center gap-2 text-xs font-mono uppercase tracking-wider text-zinc-500 hover:text-white mb-8">
          <ArrowLeft className="h-3.5 w-3.5" /> Zurück
        </Link>
        <h1 className="font-display font-black tracking-tighter text-4xl md:text-5xl mb-10">{title}</h1>
        <div className="prose prose-invert max-w-none text-zinc-300 leading-relaxed space-y-5 [&_h2]:font-display [&_h2]:text-2xl [&_h2]:font-bold [&_h2]:text-white [&_h2]:mt-10 [&_h2]:mb-3 [&_h3]:font-display [&_h3]:font-bold [&_h3]:text-white [&_h3]:mt-6 [&_h3]:mb-2 [&_a]:text-[#FF0050] [&_a]:underline-offset-4 hover:[&_a]:underline">
          {children}
        </div>
      </section>
      <Footer />
    </div>
  );
}

export function Impressum() {
  return (
    <LegalShell title="Impressum">
      <p>Angaben gemäß § 5 TMG.</p>
      <h2>Anbieter</h2>
      <p>
        Jasko Hodzic<br />
        Friedenstraße 2<br />
        42699 Solingen<br />
        Deutschland
      </p>
      <h2>Kontakt</h2>
      <p>
        Telefon: <a href="tel:+4915223701174">+49 1522 3701174</a><br />
        E-Mail: <a href="mailto:info@viralcrew.de">info@viralcrew.de</a>
      </p>
      <h2>Umsatzsteuer-ID</h2>
      <p>Umsatzsteuer-Identifikationsnummer gemäß § 27 a Umsatzsteuergesetz: <strong>DE 368328094</strong></p>
      <h2>Verantwortlich für den Inhalt (§ 18 Abs. 2 MStV)</h2>
      <p>Jasko Hodzic, Anschrift wie oben.</p>
      <h2>EU-Streitschlichtung</h2>
      <p>Die Europäische Kommission stellt eine Plattform zur Online-Streitbeilegung (OS) bereit: <a href="https://ec.europa.eu/consumers/odr/" target="_blank" rel="noopener noreferrer">ec.europa.eu/consumers/odr</a>. Wir sind nicht verpflichtet und nicht bereit, an einem Streitbeilegungsverfahren vor einer Verbraucherschlichtungsstelle teilzunehmen.</p>
      <h2>Haftungsausschluss</h2>
      <h3>Haftung für Inhalte</h3>
      <p>Als Diensteanbieter sind wir gemäß § 7 Abs.1 TMG für eigene Inhalte auf diesen Seiten nach den allgemeinen Gesetzen verantwortlich. Nach §§ 8 bis 10 TMG sind wir als Diensteanbieter jedoch nicht verpflichtet, übermittelte oder gespeicherte fremde Informationen zu überwachen.</p>
      <h3>Haftung für Links</h3>
      <p>Unser Angebot enthält Links zu externen Webseiten Dritter, auf deren Inhalte wir keinen Einfluss haben. Deshalb können wir für diese fremden Inhalte auch keine Gewähr übernehmen.</p>
      <h3>Urheberrecht</h3>
      <p>Die durch die Seitenbetreiber erstellten Inhalte und Werke auf diesen Seiten unterliegen dem deutschen Urheberrecht.</p>
      <h2>Hinweis zu TikTok Shop</h2>
      <p>ViralCrew ist eine offizielle TikTok Shop Partner-Agentur (TikTok Shop Affiliate Partner / MCN). „TikTok" ist eine Marke der ByteDance Ltd. ViralCrew steht in keinem gesellschaftsrechtlichen Verhältnis zu ByteDance/TikTok.</p>
    </LegalShell>
  );
}

export function Datenschutz() {
  return (
    <LegalShell title="Datenschutzerklärung">
      <h2>1. Verantwortlicher</h2>
      <p>Jasko Hodzic, Friedenstraße 2, 42699 Solingen, Deutschland · <a href="mailto:info@viralcrew.de">info@viralcrew.de</a> · +49 1522 3701174</p>
      <h2>2. Erhebung allgemeiner Informationen</h2>
      <p>Beim Aufruf unserer Webseite werden automatisch Informationen allgemeiner Natur erfasst (Browsertyp, Betriebssystem, Domainname, IP-Adresse, Datum/Uhrzeit des Zugriffs). Diese Verarbeitung erfolgt auf Grundlage von Art. 6 Abs. 1 lit. f DSGVO zur Sicherstellung eines reibungslosen Verbindungsaufbaus und der Systemsicherheit.</p>
      <h2>3. Kontaktformular & WhatsApp</h2>
      <p>Wenn du uns über das Kontaktformular, per E-Mail oder WhatsApp (+49 1522 3701174) kontaktierst, verarbeiten wir deine Angaben (Name, E-Mail, TikTok-Handle, Nachricht) zur Bearbeitung der Anfrage. Rechtsgrundlage: Art. 6 Abs. 1 lit. b und lit. f DSGVO.</p>
      <h2>4. Account & Authentifizierung</h2>
      <p>Wenn wir dir einen Creator/Brand-Account zur Verfügung stellen, speichern wir E-Mail-Adresse, Name, Rolle (Creator/Brand) und Aktivitätsdaten. Bei Login via Google verarbeiten wir Name, E-Mail und Profilbild von Google.</p>
      <h2>5. Cookies</h2>
      <p>Wir verwenden technisch notwendige Cookies (Session/JWT) für die Anmeldung. Ohne diese Cookies ist eine Nutzung des Dashboards nicht möglich.</p>
      <h2>6. Empfänger / Auftragsverarbeiter</h2>
      <p>Hosting & Infrastruktur, Zahlungsabwicklung (Whop Inc.), E-Mail-Dienstleister. Mit allen Auftragsverarbeitern bestehen Verträge gemäß Art. 28 DSGVO.</p>
      <h2>7. Deine Rechte</h2>
      <p>Du hast jederzeit das Recht auf Auskunft (Art. 15), Berichtigung (Art. 16), Löschung (Art. 17), Einschränkung (Art. 18), Datenübertragbarkeit (Art. 20) und Widerspruch (Art. 21). Anfragen bitte an <a href="mailto:info@viralcrew.de">info@viralcrew.de</a>.</p>
      <h2>8. Beschwerderecht</h2>
      <p>Du kannst dich jederzeit bei der zuständigen Aufsichtsbehörde (Landesbeauftragte für Datenschutz NRW) beschweren.</p>
      <h2>9. Speicherdauer</h2>
      <p>Wir speichern Daten nur so lange, wie es für die jeweiligen Zwecke erforderlich ist oder gesetzliche Aufbewahrungspflichten bestehen (z.B. 10 Jahre für Rechnungsunterlagen).</p>
    </LegalShell>
  );
}

export function AGB() {
  return (
    <LegalShell title="Allgemeine Geschäftsbedingungen">
      <h2>§ 1 Geltungsbereich</h2>
      <p>Diese AGB gelten für alle Verträge zwischen Jasko Hodzic (ViralCrew, Friedenstraße 2, 42699 Solingen, „Agentur") und den Nutzern der Plattform viralcrew.de (Creator und Brands).</p>
      <h2>§ 2 Leistungen</h2>
      <p>ViralCrew vermittelt als TikTok Shop Partner-Agentur Kooperationen zwischen Creators und Brands, stellt Trends, Produktmuster (Pro-Plan), Brand-Deals, Performance-Analytics und Beratung bereit. Konkreter Leistungsumfang ergibt sich aus der jeweils gebuchten Mitgliedschaft (Free oder Pro).</p>
      <h2>§ 3 Mitgliedschaft & Preise</h2>
      <p>Der <strong>Free-Plan</strong> ist kostenlos. Der <strong>Pro-Plan</strong> kostet <strong>19,99 € pro Monat</strong> (inkl. MwSt.) und wird über unseren Zahlungspartner Whop (Whop Inc.) abgerechnet. Die Mitgliedschaft verlängert sich automatisch monatlich.</p>
      <h2>§ 4 Vertragsschluss</h2>
      <p>Der Vertrag kommt mit Bestätigung der Mitgliedschaft über Whop oder schriftliche Aufnahme als Creator/Brand durch ViralCrew zustande.</p>
      <h2>§ 5 Kündigung</h2>
      <p>Die gesamte Abwicklung, Verwaltung und Kündigung der Pro-Mitgliedschaft erfolgt vollständig über unseren Zahlungspartner Whop (Whop Inc.). Die Mitgliedschaft ist jederzeit zum Ende des laufenden Abrechnungszeitraums über das Whop-Konto kündbar. ViralCrew nimmt selbst keine Zahlungs- oder Kündigungsabwicklung vor; es gelten ergänzend die Bedingungen von Whop.</p>
      <h2>§ 6 Pflichten der Creator</h2>
      <p>Creator verpflichten sich, TikTok Community-Richtlinien und gesetzliche Vorgaben (insb. Kennzeichnungspflicht, UWG) einzuhalten. Bei Verstößen kann ViralCrew die Mitgliedschaft fristlos beenden.</p>
      <h2>§ 7 Provisionen & Auszahlungen</h2>
      <p>Provisionen werden gemäß der jeweiligen Kampagnenvereinbarung ausgezahlt. Auszahlungen erfolgen monatlich, sofern der Mindestauszahlungsbetrag erreicht ist.</p>
      <h2>§ 8 Produktmuster (Pro)</h2>
      <p>Pro-Mitglieder erhalten Produktmuster kostenfrei zur authentischen Bewerbung. Die Muster verbleiben Eigentum des jeweiligen Brands bis zur erfolgten Bewerbung.</p>
      <h2>§ 9 Haftung</h2>
      <p>Eine Haftung von ViralCrew ist – soweit gesetzlich zulässig – ausgeschlossen. ViralCrew haftet insbesondere nicht für den wirtschaftlichen Erfolg von Kampagnen, erzielte Umsätze oder Provisionen, für Entscheidungen von TikTok/ByteDance (z.B. Sperren, Ablehnungen) oder für Inhalte und Leistungen Dritter (insb. Brands und Whop). Zwingende gesetzliche Haftungstatbestände (insb. bei Vorsatz, grober Fahrlässigkeit sowie Verletzung von Leben, Körper oder Gesundheit) bleiben unberührt.</p>
      <h2>§ 10 Schlussbestimmungen</h2>
      <p>Es gilt deutsches Recht. Gerichtsstand ist – soweit zulässig – Solingen. Sollten einzelne Bestimmungen unwirksam sein, bleibt der Vertrag im Übrigen wirksam.</p>
      <p className="text-sm text-zinc-500 mt-8">Stand: Juni 2026</p>
    </LegalShell>
  );
}
